import { SignInRedirectCallback } from './sign-in-redirect-callback';

export const SignInRedirectRoutes = [
    { exact: true, path: '/auth/callback', component: SignInRedirectCallback }
];

export const SignInRedirectPaths = SignInRedirectRoutes.map((a) => a.path);
